import { useState } from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import { useVpsHostingFaqContent } from '../../../../hooks/useVpsHostingFaqContent';
import openIcon from '../../../../assets/images/vpshosting/faq/open.svg';
import closeIcon from '../../../../assets/images/vpshosting/faq/close.svg';
import './FAQ.css';

const FAQ = () => {
  const { content, isLoading } = useVpsHostingFaqContent();
  const [openIndex, setOpenIndex] = useState(0);

  if (isLoading || !content) {
    return null;
  }

  const { title, subtitle, items } = content;

  const toggleItem = (index) => {
    setOpenIndex((current) => (current === index ? -1 : index));
  };

  return (
    <section className="vps-hosting-faq">
      <div className="vps-hosting-faq__inner">
        <Reveal className="vps-hosting-faq__header">
          <h2 className="vps-hosting-faq__title">{title}</h2>
          {subtitle ? <p className="vps-hosting-faq__subtitle">{subtitle}</p> : null}
        </Reveal>

        <div className="vps-hosting-faq__list">
          {items.map(({ question, answer }, index) => {
            const isOpen = openIndex === index;

            return (
              <Reveal key={`${question}-${index}`} delay={index * 60}>
                <div
                  className={`vps-hosting-faq__item${isOpen ? ' is-open' : ''}`}
                >
                  <button
                    type="button"
                    className="vps-hosting-faq__trigger"
                    aria-expanded={isOpen}
                    onClick={() => toggleItem(index)}
                  >
                    <span className="vps-hosting-faq__question">{question}</span>
                    <img
                      className="vps-hosting-faq__icon"
                      src={isOpen ? closeIcon : openIcon}
                      alt=""
                      aria-hidden="true"
                    />
                  </button>

                  {isOpen ? (
                    <p className="vps-hosting-faq__answer">{answer}</p>
                  ) : null}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
